import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Form,
  Button,
  FormGroup,
  FormLabel,
  FormControl,
  FormCheck,
  FormSelect,
  Alert
} from 'react-bootstrap';
import {
  FaMailBulk, FaUser, FaPhone, FaCalendar,
  FaBriefcase, FaMapPin, FaHeart, FaExclamationCircle
} from 'react-icons/fa';

class UserForm extends Component {
  handleDateChange = (date) => {
    this.props.onUpdate({ dob: date });
  };

  handleSmokingChange = (e) => {
    this.props.onUpdate({ smoking: e.target.checked ? 1 : 0 });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(e);
  };

  render() {
    const {
      userData,
      userProfile,
      provinces,
      errors,
      loading
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit} className="edit-profile-form">
        {errors.submit && (
          <Alert variant="danger" className="d-flex align-items-center">
            <FaExclamationCircle size={20} className="me-2" />
            {errors.submit}
          </Alert>
        )}

        <div className="row">
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaMailBulk size={16} className="me-2 text-primary" />
                Email Address
              </FormLabel>
              <FormControl plaintext readOnly value={userData?.user_email} className="modern-input" />
            </FormGroup>
          </div>
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaUser size={16} className="me-2 text-primary" />
                Full Name *
              </FormLabel>
              <FormControl
                type="text"
                value={userProfile.name}
                onChange={(e) => this.props.onUpdate({ name: e.target.value })}
                isInvalid={!!errors.name}
                className="modern-input"
              />
              <FormControl.Feedback type="invalid">{errors.name}</FormControl.Feedback>
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaPhone size={16} className="me-2 text-primary" />
                Phone Number *
              </FormLabel>
              <FormControl
                type="text"
                value={userProfile.phone}
                onChange={(e) => this.props.onUpdate({ phone: e.target.value })}
                isInvalid={!!errors.phone}
                className="modern-input"
              />
              <FormControl.Feedback type="invalid">{errors.phone}</FormControl.Feedback>
            </FormGroup>
          </div>
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaCalendar size={16} className="me-2 text-primary" />
                Date of Birth *
              </FormLabel>
              <DatePicker
                selected={userProfile.dob}
                onChange={this.handleDateChange}
                dateFormat="dd/MMM/yyyy"
                maxDate={new Date()}
                className={`form-control modern-input ${errors.dob ? 'is-invalid' : ''}`}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              {errors.dob && <div className="invalid-feedback d-block">{errors.dob}</div>}
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaBriefcase size={16} className="me-2 text-primary" />
                Profession *
              </FormLabel>
              <FormControl
                type="text"
                value={userProfile.profession}
                onChange={(e) => this.props.onUpdate({ profession: e.target.value })}
                isInvalid={!!errors.profession}
                className="modern-input"
              />
              <FormControl.Feedback type="invalid">{errors.profession}</FormControl.Feedback>
            </FormGroup>
          </div>
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaUser size={16} className="me-2 text-primary" />
                Gender *
              </FormLabel>
              <div>
                <FormCheck
                  inline
                  label="Female"
                  name="sex"
                  type="radio"
                  value="0"
                  checked={userProfile.sex == 0}
                  onChange={(e) => this.props.onUpdate({ sex: e.target.value })}
                  className="modern-radio"
                />
                <FormCheck
                  inline
                  label="Male"
                  name="sex"
                  type="radio"
                  value="1"
                  checked={userProfile.sex == 1}
                  onChange={(e) => this.props.onUpdate({ sex: e.target.value })}
                  className="modern-radio"
                />
              </div>
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaMapPin size={16} className="me-2 text-primary" />
                Location *
              </FormLabel>
              <FormSelect
                value={userProfile.location}
                onChange={(e) => this.props.onUpdate({ location: e.target.value })}
                isInvalid={!!errors.location}
                className="modern-input"
              >
                <option value="">Select Province</option>
                {provinces.map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </FormSelect>
              <FormControl.Feedback type="invalid">{errors.location}</FormControl.Feedback>
            </FormGroup>
          </div>
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">
                <FaHeart size={16} className="me-2 text-primary" />
                Marital Status *
              </FormLabel>
              <div>
                <FormCheck
                  inline
                  label="Single"
                  name="marriage"
                  type="radio"
                  value="0"
                  checked={userProfile.marriage == 0}
                  onChange={(e) => this.props.onUpdate({ marriage: e.target.value })}
                  className="modern-radio"
                />
                <FormCheck
                  inline
                  label="Married"
                  name="marriage"
                  type="radio"
                  value="1"
                  checked={userProfile.marriage == 1}
                  onChange={(e) => this.props.onUpdate({ marriage: e.target.value })}
                  className="modern-radio"
                />
                <FormCheck
                  inline
                  label="Widow"
                  name="marriage"
                  type="radio"
                  value="2"
                  checked={userProfile.marriage == 2}
                  onChange={(e) => this.props.onUpdate({ marriage: e.target.value })}
                  className="modern-radio"
                />
              </div>
            </FormGroup>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <FormGroup>
              <FormLabel className="fw-semibold">Smoking Habit</FormLabel>
              <FormCheck
                type="switch"
                label={userProfile.smoking == 1 ? "Yes" : "No"}
                checked={userProfile.smoking == 1}
                onChange={this.handleSmokingChange}
                className="modern-switch"
              />
            </FormGroup>
          </div>
        </div>

        <FormGroup className="mb-4">
          <FormLabel className="fw-semibold">Bio *</FormLabel>
          <FormControl
            as="textarea"
            rows={4}
            value={userProfile.bio}
            onChange={(e) => this.props.onUpdate({ bio: e.target.value })}
            isInvalid={!!errors.bio}
            className="modern-input"
            placeholder="Tell us about yourself..."
          />
          <FormControl.Feedback type="invalid">{errors.bio}</FormControl.Feedback>
        </FormGroup>

        <div className="d-flex gap-3">
          <Button
            type="submit"
            variant="primary"
            disabled={loading}
            className="modern-button"
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
          <Button
            variant="outline-secondary"
            onClick={this.props.onCancel}
            disabled={loading}
            className="modern-button"
          >
            Cancel
          </Button>
        </div>
      </Form>
    );
  }
}

export default UserForm;
